/**
 * Test IDs for QA automation.
 */
export const testIds = {
  liveTripsTrackerLayoutNavigation: "live-trips-tracker-layout-navigation",
  liveTripsTrackerMapView: "live-trips-tracker-map-view",
  liveTripsTrackerBoardView: "live-trips-tracker-board-view",
  liveTripsTrackerEntityNavigation: "live-trips-tracker-entity-navigation",
  liveTripsTrackerTripsView: "live-trips-tracker-trips-view",
  liveTripsTrackerOrdersView: "live-trips-tracker-orders-view",
  liveTripsTrackerDriversView: "live-trips-tracker-drivers-view",
  liveTripsTrackerEventsView: "live-trips-tracker-events-view",
} as const;
